import React, { useEffect, useState, useMemo } from "react"
import { useDispatch } from "react-redux"
import { get, isEmpty, findKey } from "lodash"
import uuid from "uuid"
import ClassNames from "classnames"

import { Panel } from "components/organisms/panel"
import { Labels } from "components/atoms/input/input"
import { InfoTable, SeparateTable } from "components/molecules/table"
import MiddleChart from "components/molecules/chart/middleChart"
import { StatisticList } from "components/molecules/list/statistics"
import { ComplexIndexPanel } from "components/organisms/panel/ratio"
import { ComplexIndexPanelSp } from "components/organisms/panel/ratioSp"
import { tableColumns, infoTableColumns } from "config/table_columns"
import { APIResponse } from "redux/apis/types"
import { changeSymbol, changeSpModalSymbol } from "redux/ducks/Chart"
import * as Formatter from "utils/Formatter"
import { SECURITY_TYPE } from "config/const"
import { ROUTE_LIST } from "config/const"
import { NewsList } from "components/organisms/panel/newsList"
import { checkIsSp } from "utils/util"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { statisticsApiCall } from "components/actions/divisionStatistics"

type PropsType = {
  indexData: APIResponse.Res | {}
  setIndexData: Function
  changeIndexType?: Function
  statisticsData: Array<object>
  updateStatistics: Function
  detailsData: APIResponse.Res
  selectData: number
  setSelectData: Function
  transitionData: object
  requestIndex: Function
}

const label = [
  { id: "Main", name: "主要指標" },
  { id: "Tse", name: "東証" },
  { id: "Emerging", name: "新興市場" },
  { id: "All", name: "すべて" },
]

export const DomesticIndexTemplate: React.FC<PropsType> = props => {
  const isPhone = useMemo(() => {
    return checkIsSp()
  }, [])
  const [activeLabel, changeLabel] = useState<string>(label[0].id)
  const [checkTransitionData, setCheckTransitionData] = useState(false)
  const [screenSize, setScreenSize] = useState(window.outerWidth)
  const [newsEffect, setNewsEffect] = useState(false)
  const [transitionFlag, setTransitionFlag] = useState(false)

  const resultList: Array<APIResponse.Res> | [] = get(
    props.indexData,
    "ResultList",
    []
  )

  const canvasId = useMemo(() => {
    return uuid()
  }, [])
  const dispatch = useDispatch()

  useEffect(() => {
    !!props.changeIndexType && props.changeIndexType(activeLabel)
  }, [activeLabel])

  useEffect(() => {
    if (isEmpty(resultList) || !isEmpty(props.transitionData) || transitionFlag)
      return
    dispatch(changeSymbol(canvasId, resultList[0]))
  }, [resultList])

  useEffect(() => {
    if (isEmpty(props.transitionData) || isEmpty(props.indexData)) return
    if (props.transitionData && !checkTransitionData) {
      const resultList: Array<APIResponse.Res> | [] = get(
        props.indexData,
        "ResultList",
        []
      )
      const activePosition = findKey(resultList, (row: object) => {
        const symbol = get(props.transitionData, "Symbol")
        return get(row, "Symbol") === symbol
      })
      props.setSelectData(Number(activePosition))
      dispatch(changeSymbol(canvasId, props.transitionData))
      setCheckTransitionData(true)
      setTransitionFlag(true)
    }
  }, [props.transitionData, props.indexData])

  useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenSize(window.innerWidth)
    })
  })

  return (
    <MainContainer className="symmetry-layout domestic-index-template">
      <div className="contents-block">
        <div className="contents-nest-block">
          <Panel
            className="panel-list"
            title=""
            // refresh={() => props.requestIndex({ setData: props.setIndexData })}
            filter={
              <div className="control-row sp">
                <Labels
                  className="btn-segmented-control btn-thin liquid-control right-justify"
                  labelList={label}
                  onChange={(id: string) => {
                    changeLabel(id)
                    props.setSelectData(0)
                    setNewsEffect(true)
                    setTransitionFlag(false)
                  }}
                  checked={activeLabel}
                />
              </div>
            }
          >
            <div
              className={ClassNames(
                "result-list-block domestic-index-list-block",
                { all: activeLabel === label[3].id }
              )}
            >
              <SeparateTable
                className="table-list-view table-liquid-cell"
                list={tableColumns.index.summary}
                data={resultList}
                active={props.selectData}
                scrollable={screenSize > 559 && activeLabel === label[3].id}
                onClick={(data: any, i: number) => {
                  !isPhone
                    ? dispatch(changeSymbol(canvasId, data))
                    : dispatch(changeSpModalSymbol(data))
                  props.setSelectData(i)
                }}
              />
            </div>
          </Panel>
          <Panel
            title={
              <>
                <span className="panel-header-title-items">市場統計</span>
                {/*<span className="panel-header-title-items">*/}
                {/*  <div className="time-col liquid-item">*/}
                {/*    {Formatter.date(*/}
                {/*      get(props.statisticsData[0], "CreatedTime"),*/}
                {/*      "MM/DD HH:mm"*/}
                {/*    )}*/}
                {/*  </div>*/}
                {/*</span>*/}
              </>
            }
            className="panel-market-statistics"
            // refresh={() => {
            //   statisticsApiCall({
            //     updateStatistics: props.updateStatistics,
            //     division: "0111,0114,0124,0126",
            //   })
            // }}
          >
            <StatisticList statisticsData={props.statisticsData} />
          </Panel>
        </div>
      </div>
      <div className="contents-block index-detail-block">
        <div className="contents-nest-block">
          {!isPhone && (
            <Panel className="panel-main-index" title="" nonePanelHeader={true}>
              <MiddleChart id={canvasId} />
              <InfoTable
                list={infoTableColumns.indexes}
                data={get(props.detailsData, "Symbol")}
                className="table-striped table-index-detail"
                wrapperCls="index-detail-table-row"
              />
            </Panel>
          )}
          <NewsList
            route={ROUTE_LIST.DOMESTIC_INDEX}
            effect={newsEffect}
            setEffect={setNewsEffect}
          />
        </div>
      </div>
    </MainContainer>
  )
}

type DataItem = {
  data: APIResponse.Res
  setData: Function
  num?: number
  changeNum?: Function
  listNum?: number
  changeListNum?: Function
  dataSp?: APIResponse.Res
}

type IndustryRatioProps = {
  industryItem: DataItem
  constituentsItem: DataItem
  detailItem: DataItem
  location: object
  chartID: {
    industry: string
    constituents: string
  }
}

export const IndustryRatioTemplate: React.FC<IndustryRatioProps> = props => {
  const {
    industryItem,
    constituentsItem,
    detailItem,
    location,
    chartID,
  } = props

  const isPhone = checkIsSp()
  const dispatch = useDispatch()
  const canvasIdOfHeatMap = useMemo(() => {
    return uuid()
  }, [])

  const [labelId, changeLabelId] = useState(0)
  const [heatMapInfoData, setHeatMapInfoData] = useState<APIResponse.Res>([])

  const industryData = get(industryItem.data, "ResultList")

  const heatMapItem = {
    canvasId: canvasIdOfHeatMap,
    setInfoData: setHeatMapInfoData,
  }
  const labelItem = { label: labelId, changeLabel: changeLabelId }

  useEffect(() => {
    if (labelId === 2 && !isPhone) {
      dispatch(changeSymbol(canvasIdOfHeatMap, industryData[0]))
    }
  }, [labelId])

  return (
    <MainContainer
      className="industry-ratio-template right-thin-layout"
      blockClassName={ClassNames("scroll-block", {
        "list-block": labelId === 0,
        "heat-map-block": labelId === 2 || (isPhone && labelId === 1),
        sp: isPhone,
      })}
    >
      <div
        className={ClassNames({
          "square-block": labelId === 0,
          "chart-list-block": labelId === 1,
          "contents-block": labelId === 2 || (isPhone && labelId === 1),
        })}
      >
        {!isPhone ? (
          <ComplexIndexPanel
            industryItem={industryItem}
            constituentsItem={constituentsItem}
            detailItem={detailItem}
            location={location}
            chartID={chartID}
            heatMapItem={heatMapItem}
            labelItem={labelItem}
          />
        ) : (
          <ComplexIndexPanelSp
            industryItem={industryItem}
            constituentsItem={constituentsItem}
            detailItem={detailItem}
            location={location}
            chartID={chartID}
            heatMapItem={heatMapItem}
            labelItem={labelItem}
          />
        )}
      </div>
      {!isPhone && labelId === 2 ? (
        <div className="contents-block side-symbol-block">
          <div className="contents-nest-block">
            <Panel className="panel-main-index" title="" nonePanelHeader={true}>
              <div>
                <div>
                  <MiddleChart
                    id={canvasIdOfHeatMap}
                    numberOfStocks={get(constituentsItem.data, "TotalCount")}
                  />
                </div>
                <div>
                  <InfoTable
                    list={infoTableColumns.heatMap}
                    data={heatMapInfoData}
                    className="table-striped table-index-detail"
                    wrapperCls="index-detail-table-row"
                  />
                </div>
              </div>
            </Panel>
          </div>
        </div>
      ) : null}
    </MainContainer>
  )
}
